import { useLoggedOutCategoryPageCatNavFilterRequest } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/__internal__/useLoggedOutCategoryPageCatNavFilterRequest";
import fetchProductCatNavFilters from "@faire/web-api--source/api/v2/search/products/cat-nav/filters/post";
import { getQueryKey as getQueryKeyProductCatNavFilters } from "@faire/web-api--source/api/v2/search/products/cat-nav/filters/post-hooks";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
export var useLoggedOutCategoryPageFilterSections = function() {
    var request = useLoggedOutCategoryPageCatNavFilterRequest();
    var _useQuery = useQuery({
        queryKey: getQueryKeyProductCatNavFilters(request),
        queryFn: function() {
            return fetchProductCatNavFilters(request);
        },
        staleTime: Infinity,
        placeholderData: keepPreviousData
    }), data = _useQuery.data, isFetching = _useQuery.isFetching;
    var _data_filter_sections;
    return {
        data: {
            filterSections: (_data_filter_sections = data === null || data === void 0 ? void 0 : data.filter_sections) !== null && _data_filter_sections !== void 0 ? _data_filter_sections : []
        },
        isFetching: isFetching
    };
};
